import { createSlice } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTimetable } from "../services/lessonService";
import { createCustomAsyncThunk } from "./utils";
import dayjs from "dayjs";

const get = createCustomAsyncThunk(
    "timetable/get",
    async params => await getTimetable(params)
)

const timetableSlice = createSlice({
    name: "timetable",
    initialState: {
        data: [],
        isLoading: true,
        error: null,
        dates: {
            startDate: null,
            endDate: null,
            value: null
        }
    },
    reducers: {
        setDates: (state, action) => { state.dates = action.payload }
    },
    extraReducers: builder => {
        builder
            .addCase(get.pending, state => { state.isLoading = true })
            .addCase(get.fulfilled, (state, action) => {
                state.data = action.payload
                state.isLoading = false
            })
            .addCase(get.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

const { setDates } = timetableSlice.actions

export default timetableSlice.reducer

export const useTimetable = (type, id, mainGroup, studyYear) => {

    const dispatch = useDispatch()

    const { data, isLoading, dates } = useSelector(x => x.timetable)

    const handleSetDates = React.useCallback(dates => dispatch(setDates(dates)), [dispatch])

    React.useEffect(() => {
        const dayParams = {
            startDate: dayjs().locale('ru-ru').weekday(0),
            endDate: dayjs().locale('ru-ru').weekday(6),
            value: dayjs().locale('ru-ru').weekday(0)
        }
        handleSetDates(dayParams)
    }, [handleSetDates])

    React.useEffect(() => {
        if (type && id && dates.startDate && dates.endDate) {
            dispatch(get({
                start_date: dates.startDate?.toISOString()?.slice(0, 10),
                end_date: dates.endDate?.toISOString()?.slice(0, 10),
                ...(type === "employee" && { employee: id }),
                ...(type === "student" && { student: id }),
                ...(type === "employee" && mainGroup !== undefined && mainGroup !== null && { main_group: mainGroup }),
                ...(type === "employee" && studyYear && { study_year: studyYear }),
            }))
        }
    }, [dispatch, type, id, dates, mainGroup, studyYear])

    return { data, dates, handleSetDates, isLoading }
}